import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import PageWithHeadline from '@/components/layout/PageWithHeadline';
import { PageContentCard } from '@/components/layout/PageContentCard';
import { useDeviceModels } from '../hooks';
import { DeviceModelsTable } from './DeviceModelsTable';
import type { DeviceModel } from '../types';

export function DeviceModelsPage() {
  const { data: models, isLoading } = useDeviceModels();
  const navigate = useNavigate();

  const handleManageFirmware = useCallback(
    (model: DeviceModel) => {
      navigate({ to: '/device-models/$modelId/firmware', params: { modelId: String(model.id) } });
    },
    [navigate]
  );

  return (
    <PageWithHeadline headlineKey="deviceModels.title">
      <PageContentCard className="flex-1 min-h-0 flex flex-col w-full">
        <DeviceModelsTable
          models={models || []}
          isLoading={isLoading}
          onManageFirmware={handleManageFirmware}
        />
      </PageContentCard>
    </PageWithHeadline>
  );
}
